<template>
  <div class="spinner-container">
    <div class="loading-spinner" :style="spinnerStyle">
      <div
        v-for="n in 12"
        :key="n"
        class="spinner-blade"
        :style="{
          transform: `rotate(${(n - 1) * 30}deg)`,
          animationDelay: `${(n - 1) * 0.1}s`,
        }" />
    </div>
  </div>
</template>

<script>

export default {
  name: "LoadingSpinner",
  props: {
    size: {
      type: Number,
      default: 40,
    },
    color: {
      type: String,
      default: "#FFD700",
    },
  },
  computed: {
    spinnerStyle() {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`,
      };
    },
  },
};

</script>

<style scoped>
.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-spinner {
  position: relative;
}

.spinner-blade {
  position: absolute;
  left: 44.5%;
  width: 11%;
  height: 28%;
  background-color: v-bind(color);
  border-radius: 50%/20%;
  transform-origin: 50% 150%;
  animation: spinner-fade 1s linear infinite;
}

@keyframes spinner-fade {
  0% {
    opacity: 0.85;
  }
  50% {
    opacity: 0.25;
  }
  100% {
    opacity: 0.25;
  }
}
</style>
